<template>
  <div>
    <a-card :bordered="false">
      <a-space style="margin-bottom: 12px">
        <a-button type="primary" v-if="isAdmin" @click="showAddModal">添加新单号</a-button>
        <a-button type="primary" v-if="isAdmin" @click="showAddTrackModal">添加轨迹</a-button>
      </a-space>

      <a-table :columns="columns" :data-source="recordList" :loading="dataLoading" :row-key="(record) => record.id" :pagination="false">
        <template slot="datetime" slot-scope="text,record">
          <span v-if="record.status == 0"> {{ currentDate }} </span>
          <span v-else>{{ record.datetime }}</span>
        </template>
        <template slot="destination" slot-scope="text,record">
          <a-tag v-if="record.status == 0" color="#ccc"> 暂无 </a-tag>
          <span v-else>{{ record.destination }}</span>
        </template>
        <template slot="position" slot-scope="text,record">
          <a-tag v-if="record.status == 0" color="#ccc"> 暂无 </a-tag>
          <span v-else>{{ record.position }}</span>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag v-if="record.status == 0" color="#ccc"> {{ record.status_str }} </a-tag>
          <a-tag v-else-if="record.status == 1" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 2" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 3" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 4" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 5" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 6" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 7" color="#165dff"> {{ record.status_str }}, 已发出{{ record.inteval_day }}天</a-tag>
          <a-tag v-else-if="record.status == 8" color="#00b42a"> {{ record.status_str }}, 已签收{{ record.inteval_day }}天</a-tag>
          <a-tag v-else color="#f50">错误状态：{{ record.status }}</a-tag>
        </template>
        <template slot="note" slot-scope="text, record">
          <a-tooltip :title="record.note">
            <a-tag v-if="record.status == 0" color="#ccc"> 该包裹尚未入库 </a-tag>
            <div v-else>{{ record.note }}</div>
          </a-tooltip>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button v-if="isAdmin && record.status !== 0" type="default" size="small" icon="edit" @click="showEdit(record)"></a-button>
            <a-popconfirm title="确认删除吗?" ok-text="确认" cancel-text="取消" @confirm="deleteCodes(record)">
              <a-button v-if="isAdmin && record.status !== 0" type="danger" size="small" icon="delete"></a-button>
            </a-popconfirm>
          </a-space>
        </template>
        <template slot="expandedRowRender" slot-scope="record">
          <a-timeline>
            <a-timeline-item v-for="(item, index) in record.detail_list || []" :key="index">
              <div class="track-item-container">
                <div class="track-item-content">
                  <span style="margin-right: 24px">{{ item.datetime }}</span>
                  <span>{{ item.destination ? item.destination + "，" : "" }}</span>
                  <span>{{ item.position ? item.position + "，" : "" }}</span>
                  <span>{{ item.status_str ? item.status_str + "，" : "" }}</span>
                  <span>{{ item.note }}</span>
                </div>
                <div class="track-item-action">
                  <a-popconfirm title="确认删除吗?" ok-text="确认" cancel-text="取消" @confirm="deleteTrackItem(item)">
                    <a href="javascript:;" v-if="isAdmin">删除</a>
                  </a-popconfirm>
                </div>
              </div>
            </a-timeline-item>
          </a-timeline>
        </template>
      </a-table>
    </a-card>

    <!-- 添加新单号 -->
    <a-modal :visible="createVisible" width="45%" title="添加新单号" centered @cancel="createVisible = false">
      <template slot="footer">
        <a-button type="default" @click="createCancel">取消</a-button>
        <a-button type="primary" @click="createOk" :loading="createLoading">确定</a-button>
      </template>

      <a-form-model ref="createForm" :model="createForm" layout="vertical" :rules="createRules">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="单号" prop="code">
              <a-input placeholder="请输入单号" v-model="createForm.code"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹时间" prop="datetime">
              <a-date-picker show-time placeholder="请选择日期" format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="createForm.datetime" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="目的国家" prop="destination">
              <a-input placeholder="请输入目的国家" v-model="createForm.destination"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹位置" prop="position">
              <a-input placeholder="请输入地址" v-model="createForm.position"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹状态" prop="status">
              <a-select v-model="createForm.status" placeholder="运单状态" allowClear>
                <a-select-option :value="1"> 仓库已发出 </a-select-option>
                <a-select-option :value="2"> 机场过检中 </a-select-option>
                <a-select-option :value="3"> 口岸出境中 </a-select-option>
                <a-select-option :value="4"> 国外换装中 </a-select-option>
                <a-select-option :value="5"> 清关已完成 </a-select-option>
                <a-select-option :value="6"> 货物已抵达 </a-select-option>
                <a-select-option :value="7"> 货物派送中 </a-select-option>
                <a-select-option :value="8"> 签收成功 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
            <a-form-model-item label="轨迹详情" prop="note">
              <a-input placeholder="请输入详情" :rows="3" v-model="createForm.note" style="resize: none" type="textarea"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 添加轨迹 -->
    <a-modal :visible="createTrackVisible" width="45%" title="添加轨迹" centered @cancel="createTrackVisible = false">
      <template slot="footer">
        <a-button type="default" @click="createTrackCancel">取消</a-button>
        <a-button type="primary" @click="createTrackOk" :loading="createTrackLoading">确定</a-button>
      </template>

      <a-form-model ref="createTrackForm" :model="createTrackForm" layout="vertical" :rules="createTrackRules">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="单号" prop="code">
              <a-input placeholder="请输入单号" v-model="createTrackForm.code"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹时间" prop="datetime">
              <a-date-picker show-time placeholder="请选择日期" format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="createTrackForm.datetime" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="目的国家" prop="destination">
              <a-input placeholder="请输入目的国家" v-model="createTrackForm.destination"></a-input>
            </a-form-model-item>
          </a-col> -->
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹位置" prop="position">
              <a-input placeholder="请输入地址" v-model="createTrackForm.position"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹状态" prop="status">
              <a-select v-model="createTrackForm.status" placeholder="运单状态" allowClear>
                <a-select-option :value="1"> 仓库已发出 </a-select-option>
                <a-select-option :value="2"> 机场过检中 </a-select-option>
                <a-select-option :value="3"> 口岸出境中 </a-select-option>
                <a-select-option :value="4"> 国外换装中 </a-select-option>
                <a-select-option :value="5"> 清关已完成 </a-select-option>
                <a-select-option :value="6"> 货物已抵达 </a-select-option>
                <a-select-option :value="7"> 货物派送中 </a-select-option>
                <a-select-option :value="8"> 签收成功 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
            <a-form-model-item label="轨迹详情" prop="note">
              <a-input placeholder="请输入详情" :rows="3" v-model="createTrackForm.note" style="resize: none" type="textarea"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 更新轨迹信息 -->
    <a-modal :visible="editVisible" title="编辑轨迹" width="45%" centered @cancel="editVisible = false">
      <template slot="footer">
        <a-button type="default" @click="editCancel">取消</a-button>
        <a-button type="primary" @click="editOk" :loading="editLoading">确定</a-button>
      </template>

      <a-form-model ref="editForm" :model="editForm" layout="vertical" :rules="editRules">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="单号" prop="code">
              <a-input placeholder="请输入单号" v-model="editForm.code"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹时间" prop="datetime">
              <a-date-picker show-time placeholder="请选择日期" format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="editForm.datetime" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="目的国家" prop="destination">
              <a-input placeholder="请输入目的国家" v-model="editForm.destination"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹位置" prop="position">
              <a-input placeholder="请输入地址" v-model="editForm.position"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
            <a-form-model-item label="轨迹状态" prop="status">
              <a-select v-model="editForm.status" placeholder="轨迹状态">
                <a-select-option :value="1"> 仓库已发出 </a-select-option>
                <a-select-option :value="2"> 机场过检中 </a-select-option>
                <a-select-option :value="3"> 口岸出境中 </a-select-option>
                <a-select-option :value="4"> 国外换装中 </a-select-option>
                <a-select-option :value="5"> 清关已完成 </a-select-option>
                <a-select-option :value="6"> 货物已抵达 </a-select-option>
                <a-select-option :value="7"> 货物派送中 </a-select-option>
                <a-select-option :value="8"> 签收成功 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
            <a-form-model-item label="轨迹详情" prop="note">
              <a-input placeholder="请输入详情" v-model="editForm.note" type="textarea"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { reqCreateRecord, reqUpdateRecord, reqDeleteRecord, reqRecordList } from "@/api/index";

const columns = [
  { title: "运单号", dataIndex: "code", key: "code", align: "center" },
  {
    title: "轨迹时间",
    dataIndex: "datetime",
    key: "datetime",
    align: "center",
    scopedSlots: { customRender: "datetime" },
  },
  {
    title: "目的国家",
    dataIndex: "destination",
    key: "destination",
    align: "center",
    scopedSlots: { customRender: "destination" },
  },
  {
    title: "轨迹位置",
    dataIndex: "position",
    key: "position",
    align: "center",
    scopedSlots: { customRender: "position" },
  },
  {
    title: "轨迹状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  {
    title: "轨迹详情",
    dataIndex: "note",
    key: "note",
    ellipsis: true,
    scopedSlots: { customRender: "note" },
    align: "center",
  },
];

const innerColumns = [
  { title: "运单号", dataIndex: "code", key: "code", align: "center" },
  {
    title: "轨迹时间",
    dataIndex: "datetime",
    key: "datetime",
    align: "center",
  },
  {
    title: "目的国家",
    dataIndex: "destination",
    key: "destination",
    align: "center",
  },
  {
    title: "轨迹位置",
    dataIndex: "position",
    key: "position",
    align: "center",
  },
  {
    title: "轨迹状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
];

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns,
      innerColumns,
      innerData: [],
      createTitle: "",
      createVisible: false,
      createTrackVisible: false,
      createLoading: false,
      createTrackLoading: false,
      dataLoading: false,
      createForm: {
        new_post: 2, //2是单号,1是轨迹
        code: "", //单号
        datetime: "", //日期时间
        destination: "", //目的国
        position: "", //当前所处位置
        status: undefined, //包裹状态
        note: "", //备注
      },
      createTrackForm: {
        new_post: 1, //2是单号,1是轨迹
        code: "", //单号
        datetime: "", //日期时间
        // destination: "", //目的国
        position: "", //当前所处位置
        status: undefined, //包裹状态
        note: "", //备注
      },
      createRules: {
        code: [{ required: true, message: "请输入运单号", trigger: "blur" }],
        destination: [{ required: true, message: "请输入目的国", trigger: "blur" }],
        datetime: [{ required: true, message: "请选择日期", trigger: "change" }],
        position: [{ required: true, message: "请输入地址", trigger: "blur" }],
        status: [{ required: true, message: "请选择轨迹状态", trigger: "change" }],
        // note: [{ required: true, message: "请输入轨迹详情", trigger: "blur" }],
      },
      createTrackRules: {
        code: [{ required: true, message: "请输入运单号", trigger: "blur" }],
        datetime: [{ required: true, message: "请选择日期", trigger: "change" }],
        position: [{ required: true, message: "请输入地址", trigger: "blur" }],
        status: [{ required: true, message: "请选择轨迹状态", trigger: "change" }],
      },
      editVisible: false,
      editLoading: false,
      editForm: {},
      editRules: {
        code: [{ required: true, message: "请输入运单号", trigger: "blur" }],
        destination: [{ required: true, message: "请输入目的国家", trigger: "blur" }],
        datetime: [{ required: true, message: "请选择日期", trigger: "change" }],
        position: [{ required: true, message: "请输入地址", trigger: "blur" }],
        status: [{ required: true, message: "请选择轨迹状态", trigger: "change" }],
        note: [{ required: true, message: "请输入轨迹详情", trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {
    if (this.isAdmin) {
      if (this.columns.filter((item) => item.key === "action").length !== 0) return;
      this.columns.push({
        title: "操作",
        dataIndex: "action",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 80,
        align: "center",
      });
    }
  },
  computed: {
    ...mapState("result", ["recordList", "trackNoList"]),
    currentDate(){
      return moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
    }
  },
  methods: {
    // (单号是2,轨迹是1)
    // 显示创建单号modal对话框
    showAddModal() {
      this.createVisible = true;
    },
    // 取消创建单号
    createCancel() {
      this.$refs.createForm.resetFields();
      this.createVisible = false;
    },
    // 确定创建单号
    createOk() {
      this.createLoading = true;
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          let submitData = { ...this.createForm };
          submitData.datetime = moment(submitData.datetime).format("YYYY-MM-DD HH:mm:ss");
          let res = await reqCreateRecord({ ...submitData });
          if (res.data.code == 1) {
            this.createLoading = false;
            this.createVisible = false;
            this.$message.success(res.data.msg);
            this.$refs.createForm.resetFields();
            this.getTrackData();
          } else {
            this.createLoading = false;
            this.$message.error(res.data.msg);
          }
        } else {
          this.createLoading = false;
          return false;
        }
      });
    },
    // 显示创建轨迹
    showAddTrackModal() {
      this.createTrackVisible = true;
    },
    // 取消创建轨迹
    createTrackCancel() {
      this.$refs.createTrackForm.resetFields();
      this.createTrackVisible = false;
    },
    // 创建轨迹
    createTrackOk() {
      this.createTrackLoading = true;
      this.$refs.createTrackForm.validate(async (valid) => {
        if (valid) {
          let submitData = { ...this.createTrackForm };
          submitData.datetime = moment(submitData.datetime).format("YYYY-MM-DD HH:mm:ss");
          let res = await reqCreateRecord({ ...submitData });
          if (res.data.code == 1) {
            this.createTrackLoading = false;
            this.createTrackVisible = false;
            this.$message.success(res.data.msg);
            this.$refs.createTrackForm.resetFields();
            this.getTrackData();
          } else {
            this.createTrackLoading = false;
            this.$message.error(res.data.msg);
          }
        } else {
          this.createTrackLoading = false;
          return false;
        }
      });
    },
    // 编辑
    showEdit(record) {
      // this.getTrackData()
      this.editForm = { ...record };
      this.editVisible = true;
    },
    // 取消编辑
    editCancel() {
      this.editVisible = false;
      this.$refs.editForm.resetFields();
    },
    // 确定编辑
    editOk() {
      this.editLoading = true;
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          let { id, new_post, datetime, code, destination, position, note, status, detail_list } = this.editForm;
          let temp = [];
          detail_list.forEach((item) => {
            temp.push(item.code);
          });

          const submitData = {
            id,
            new_post,
            datetime,
            code,
            destination,
            position,
            note,
            status,
          };
          submitData.codes = temp;
          submitData.datetime = moment(submitData.datetime).format("YYYY-MM-DD HH:mm:ss");
          let res = await reqUpdateRecord({ ...submitData });
          if (res.data.code == 1) {
            this.editLoading = false;
            this.editVisible = false;
            this.$message.success(res.data.msg);
            this.$refs.editForm.resetFields();
            this.getTrackData();
          } else {
            this.editLoading = false;
            this.$message.error(res.data.msg);
          }
        } else {
          this.editLoading = false;
          return false;
        }
      });
    },
    // 删除
    async deleteCodes(record) {
      const res = await reqDeleteRecord(record.id);
      if (res.data.code == 1) {
        this.$message.success(res.data.msg);
        // 成功后需要重新请求轨迹数据
        this.getTrackData();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 删除轨迹
    async deleteTrackItem(item) {
      const res = await reqDeleteRecord(item.id);
      if (res.data.code == 1) {
        this.$message.success(res.data.msg);
        // 成功后需要重新请求轨迹数据
        this.getTrackData();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 请求轨迹数据
    async getTrackData() {
      this.dataLoading = true;
      const res = await reqRecordList({ codes: [...this.trackNoList] });
      if (res.data.code === 1) {
        // this.$message.success(res.data.msg);
        this.$store.commit("result/updateRecordList", res.data.data);
        this.dataLoading = false;
      } else {
        this.$message.error(res.data.msg);
        this.dataLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.track-item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
